<template lang="html">
  <div class="privilege-notice">
    <div class="privilege-notice-main">
      <h1>温馨提示</h1>
      <p>由于很多朋友买完课才知道精品课畅学卡功能，</p>
      <p>因此推出最新购买课程3天内可补差价活动！</p>
      <p>祝您学习愉快！</p>
    </div>
    <div class="close-btn" @click="$emit('closeNotice')">
      <img src="../../assets/icons/notice-close.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivilegeNotice'
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.privilege-notice {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  background-color: rgba(#000, .3);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  &-main {
    width: rem(530);
    background-color: #fff;
    padding: rem(49) rem(37) rem(75);
    box-sizing: border-box;
    line-height: 1.4;
    border-radius: rem(10);
    margin-bottom: rem(49.5);
    h1 {
      font-size: rem(36);
      text-align: center;
      margin-bottom: rem(33);
    }
    p {
      font-size: rem(28);
      color: #999;
      margin-bottom: rem(30);
      &:last-child {
        color: #F48F00;
        margin-bottom: 0;
      }
    }
  }
  .close-btn {
    width: rem(55);
    > img {
      width: 100%;
    }
  }
}
</style>
